import { ReadonlyHeaders } from "next/dist/server/web/spec-extension/adapters/headers";
import { LANGUAGE_SETTINGS_KEYNAME_LOCAL_STORAGE } from "./i18n.consts";
import { AvailableLanguageOnApp, LangCompleteData } from "./types/i18n.types";
import { funnelLangUsage } from "./i18n.func";

export const checkLangLocaleStorage = (
  langInApp: LangCompleteData,
  lang: AvailableLanguageOnApp
) => {
  let appInitialLang;
  let langSavedInLocalStorage;
  if (typeof window !== "undefined") {
    langSavedInLocalStorage = window.localStorage.getItem(
      LANGUAGE_SETTINGS_KEYNAME_LOCAL_STORAGE
    ) as AvailableLanguageOnApp;
  }

  if (langSavedInLocalStorage) {
    if (langInApp?.[langSavedInLocalStorage] !== undefined) {
      appInitialLang = langInApp[langSavedInLocalStorage];
    } else {
      appInitialLang = langInApp[lang];
      appInitialLang.isDefault = true;
    }
  } else {
    appInitialLang = langInApp[lang];
    appInitialLang.isDefault = true;
  }

  return appInitialLang;
};

export const getLangFromHeaders = (headersList: ReadonlyHeaders) => {
  const acceptLanguageHeader = headersList.get("accept-language");
  let localeBrowser = "en-US";

  if (acceptLanguageHeader) {
    try {
      const allLanguages = acceptLanguageHeader.split(";");
      const mainLanguageLocaleAndLanguage = allLanguages[0];
      const [locale, language] = mainLanguageLocaleAndLanguage.split(",");
      localeBrowser = locale;
    } catch (e) {
      console.error("Could not read headers. Error : ", e);
      console.error("Could not read headers. Headers : ", acceptLanguageHeader);
    }
  }

  const langChecked = funnelLangUsage(localeBrowser);

  return langChecked;
};
